
import React, { useMemo, useState, useEffect } from 'react';
import Grid from './Grid';
import Tiles from './Tiles';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import DataTable from 'react-data-table-component';
import dashboardJson from '../json-data/dgdashboard.json'
import { PiDotsThreeVerticalBold } from "react-icons/pi";
import Popover from 'react-bootstrap/Popover';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import ExpandedRowComponent from "../pages/grid-orderdetails";
import Tooltip from 'react-bootstrap/Tooltip';
import { ListGroup } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { configData } from '../config/systemconfigurationconstants';
import * as AWS from 'aws-sdk';
import DashboardGridData from './dashboard-data-grid';
import DashboardTiles from './dashboard-tiles';
import { ToastContainer, toast } from "react-toastify";
import CreateLoan from '../pages/Modal/create-loan';
import DashboardDatepicker from './dashboard-date-picker';
import { findWindows } from 'windows-iana';
import Header from '../components/Header';
import { RiArrowRightCircleFill } from "react-icons/ri";
import { useEncryption } from '../customHooks/useEncryption';
let defaultUseCase = '';
let defaultCient = '';
let defaultRole = '';
let userMappingData = [],
    mappingIDForUser = 0,
    usecaseList = [],
    userRoleList = [],
    clientList = [],
    userMappingDataForSupervisor = [],
    loanNumberSearch = "",
    // usecaseListForLoanCreation = [],
    // clientListForLoanCreation = [],
    usersList = [],
    userSecurityId = '',
    usecaseForSwitchAcc = '',
    clientForSwitchAcc = '',
    userRoleForSwitchAcc = ''
// For Date picker
let globalFromDate = "",
    globalToDate = "";
/**
 * MainContent component renders the main content area of the application.
 * It includes search functionality, date filters, and loan creation.
 *
 * @component
 * @param {Object} props - The component props
 * @param {Object} props.data - The data object containing loan details and count details
 * @param {Function} props.onRefresh - The function to call when the refresh button is clicked
 *
 * @example
 * <MainContent data={data} onRefresh={handleRefresh} />
 *
 * @version 1.0.0
 *
 * @returns {JSX.Element} The rendered component
 *
 * @function handleFilterChange
 * @description Handles the change of the active filter
 * @param {string} filterType - The type of filter to apply
 *
 * @function handleSearchChange
 * @description Handles the change of the search text input
 * @param {Object} event - The event object from the input change
 *
 * @function handleCreateLoan
 * @description Handles the click event for the "Create Loan" button
 *
 * @function handleSearchButtonClick
 * @description Handles the click event for the "Search" button
 *
 * @function handleFromDateChange
 * @description Handles the change of the from date input
 * @param {Object} event - The event object from the input change
 *
 * @function handleToDateChange
 * @description Handles the change of the to date input
 * @param {Object} event - The event object from the input change
 *
 * @function filteredLoanDetails
 * @description Filters the loan details based on the search text and date range
 * @returns {Array} The filtered loan details
 * @complexity O(n) - The filtering operation iterates over the loan details array once
 */
/**
 * MainContent component renders the main content area of the application.
 * It includes search functionality, date filters, and loan creation.
 *
 * @component
 * @param {Object} props - The component props
 * @param {Object} props.data - The data object containing loan details and count details
 * @param {Function} props.onRefresh - The function to call when the refresh button is clicked
 *
 * @example
 * <MainContent data={data} onRefresh={handleRefresh} />
 *
 * @version 1.0.0
 */
const MainContent = () => {
    const defaulttoDate = new Date();
    const defaultfromDate = new Date();
    defaultfromDate.setDate(defaulttoDate.getDate() - 29);
    // switch Account
    const [mainUsecaseValue, setMainUsecaseValue] = useState();
    const [mainClientValue, setMainClientValue] = useState();
    //Reset Loan Usestates
    const [showCreateLoan, setShowCreateLoan] = useState(false);
    const [showHeader, setShowHeader] = useState(false);
    const closeCreateLoan = () => setShowCreateLoan(false);
    const handleCreateLoan = () => setShowCreateLoan(true);
    // const [resetLoanshow, setResetLoanshow] = useState(false);
    // const CloseResetLoan = () => setResetLoanshow(false);
    // const showResetLoan = () => setResetLoanshow(true);
    //  admindetails = {},

    // for usermaping
    const [usecaseForMapping, setUsecaseForMapping] = useState();
    const [clientForMapping, setClientForMapping] = useState();
    const [userRoleForMapping, setUserRoleForMapping] = useState();
    const [disableClientMapping, setDisableClientMapping] = useState(true);
    const [disableRoleMapping, setDisableRoleMapping] = useState(true);
    const [usecasesForSupervisorDrpDwn, setUsecasesForSupervisorDrpDwn] = useState([]);
    const [clientsForSupervisorDrpDwn, setClientsForSupervisorDrpDwn] = useState([]);
    const [createLoanUsecase, setCreateLoanUsecase] = useState('');
    const [createLoanClient, setCreateLoanClient] = useState('');
    const [dotloader, setDotLoader] = useState(false);
    const [usecaseListForLoanCreation, setUsecaseListForLoanCreation] = useState([]);
    const [clientListForLoanCreation, setClientListForLoanCreation] = useState([]);
    const [admindetails, setAdmindetails] = useState({});
    const [showhideLoan, setShowhideLoan] = useState(false);
    const [searchValue, setSearchValue] = useState('');

    const loanProps = {
        usecaseListForLoanCreations: usecaseListForLoanCreation,
        clientListForLoanCreations: clientListForLoanCreation,
        admindetailsFromMain: admindetails,
        loanDetatils: null
    };



    // const headers = ['LN'];
    const headers = ['LN', 'BLN', 'PRO', 'LP', 'LA', 'PA', 'LE', 'LSts', 'InLSts', 'AprSts'];

    // let dashboardGridResponse=[];
    const [dashboardGridResponse, setDashboardGridResponse] = useState();
    const [dashboardGridHeader, setDashboardGridHeader] = useState([])
    const [dashboardGridLoanDeatails, setDashboardGridLoanDeatails] = useState([]);
    const [dashboardTilesData, SetDashboardTilesData] = useState([]);
    const [originalDashboardData, setOriginalDashboardData] = useState([]); // Store the original data
    let clientkeys = [];
    const { encrypt, decrypt } = useEncryption();
    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return decodeURIComponent(parts.pop().split(';').shift());
        }
        return null;
    };
    // AWS Key Details
    const lambda = new AWS.Lambda({
        region: configData.LAMBDA_REGION,
        accessKeyId: decrypt(getCookie('ak')),
        secretAccessKey: decrypt(getCookie('sk'))
    });
    const [activeFilter, setActiveFilter] = useState('');
    const [searchText, setSearchText] = useState('');
    // const [fromDate, setFromDate] = useState('');
    // const [toDate, setToDate] = useState('');
    const [startDate, setStartDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [currentRow, setCurrentRow] = useState(null);
    const TooltipTop = ({ id, children, title }) => (
        <OverlayTrigger placement='top' overlay={<Tooltip id={id}>{title}</Tooltip>}>
            <span>{children}</span>
        </OverlayTrigger>
    );
    const TooltipBottom = ({ id, children, title }) => (
        <OverlayTrigger placement='bottom' overlay={<Tooltip id={id}>{title}</Tooltip>}>
            <span>{children}</span>
        </OverlayTrigger>
    );
    const TooltipLeft = ({ id, children, title }) => (
        <OverlayTrigger placement='left' overlay={<Tooltip id={id}>{title}</Tooltip>}>
            <span>{children}</span>
        </OverlayTrigger>
    );
    const TooltipRight = ({ id, children, title }) => (
        <OverlayTrigger placement='right' overlay={<Tooltip id={id}>{title}</Tooltip>}>
            <span>{children}</span>
        </OverlayTrigger>
    );

    useEffect(() => {
        getClientMetaKey();
        getDashboardDataForGrid();
        getUserInfo();
        getUsersList();
    }, []);
    const getClientMetaKey = () => {
        const data = {
            Command: configData.GET_CLIENT_META_KEY,
            ClientShortName: localStorage.getItem('ClientShortName')?.trim(),
            UseCaseShortName: localStorage.getItem('UseCaseShortName')?.trim(),
            SecurityToken: localStorage.getItem("SecurityToken"),
            SecurityId: null,
            EventContextId: null,
            CallerSourceId: null,
            CallerSourceName: null,
        };
        const params = {
            FunctionName: configData.LAMBDA_FUNCTION_NAME1,
            Payload: JSON.stringify(data)
        };

        lambda.invoke(params, (err, data) => {
            if (err) {
                console.log(err, err.stack);
            } else {
                let lambdaResponse = JSON.parse(data.Payload.toString());
                const parsedBody = JSON.parse(lambdaResponse.body);
                console.log(parsedBody);
                console.log("getClientMetaKey()", parsedBody.Data);
                clientkeys = parsedBody.Data;
                let checkLoanLvlOROrderLvlInCls = clientkeys.filter((value) => value.MetaKey == 'DOC_CLASSIFICATION_AGGREGATION');
                let getconfigforthumbprev = clientkeys.filter((value) => value.MetaKey == 'THUMBNAIL_PREVIEW');
                localStorage.setItem('getconfigforthumbprev', getconfigforthumbprev[0]?.MetaValue)
                console.log('getClientMetaKey() - checkLoanLvlOROrderLvlInCls', checkLoanLvlOROrderLvlInCls);
                // if (checkLoanLvlOROrderLvlInCls[0].MetaValue == '1') {
                //     // Order Level  fields
                //     setClientconfigOrderLevel(true);
                //     setClientconfigLoanLevel(false);
                //     globalClientconfigOrderLevel = true;
                //     globalClientconfigLoanLevel = false;
                //     tosterText = 'Orders';
                // } else if (checkLoanLvlOROrderLvlInCls[0].MetaValue == '2') {
                //     // Loan Level fields
                //     setClientconfigOrderLevel(false);
                //     setClientconfigLoanLevel(true);
                //     globalClientconfigOrderLevel = false;
                //     globalClientconfigLoanLevel = true;
                //     tosterText = 'Loans';
                // }
            }
        });
    }
    const getDashboardDataForGrid = () => {
        const ianaTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const windowsTZ = findWindows(ianaTimeZone);
        setDotLoader(false);
        const data = {
            Command: configData.GET_DASHBOARD_DATA,
            SecurityId: null,
            SecurityToken: localStorage.getItem("SecurityToken"),
            EventContextId: null,
            CallerSourceId: null,
            CallerSourceName: null,
            // UserMapId: mappingIDForUser,
            UserMapId: Number(localStorage.getItem("mappingIDForUser")),
            ForLastXDays: 30,
            // StartDate: loanNumberSearch == "" ? globalFromDate : "",
            // EndDate: loanNumberSearch == "" ? globalToDate : "",
            // ClientLoanNumber: loanNumberSearch == "" ? null : loanNumberSearch,
            // ClientLoanNumber: loanNumberSearch == "" ? null : loanNumberSearch,
            StartDate: loanNumberSearch == "" ? formatDate(dateRange.fromDate) : "",
            EndDate: loanNumberSearch == "" ? formatDate(dateRange.toDate) : "",
            ClientLoanNumber: loanNumberSearch == "" ? null : loanNumberSearch,
            TimeZone: windowsTZ[0]
            // FinishBySlaInHrs: 10,
        };
        const params = {
            FunctionName: configData.LAMBDA_FUNCTION_NAME1,
            Payload: JSON.stringify(data)
        };

        lambda.invoke(params, (err, data) => {
            if (err) {
                console.log(err, err.stack);
            } else {
                let lambdaResponse = JSON.parse(data.Payload.toString());
                const response = JSON.parse(lambdaResponse.body);
                if (response.Status === true) {
                    setDashboardGridResponse(response);
                    setDashboardGridHeader(response.LnHdr)
                    setDashboardGridLoanDeatails(response.LoanDtls)
                    setOriginalDashboardData(response.LoanDtls)
                    SetDashboardTilesData(response.CntDtls)
                    console.log("dashboardjsonresponse", dashboardGridResponse);
                    localStorage.setItem("dashboardjson", JSON.stringify(response));
                    loanNumberSearch = "";

                    setTimeout(() => {
                        setDotLoader(true);
                    }, 1000);
                    // let getOrdDetails = JSON.parse(localStorage.getItem("dashboardjson"));
                }
                else if (response.Status === false) {
                    if (lambdaResponse.statusCode == "-30") {
                        localStorage.removeItem("SecurityToken");
                        navigate('/login');
                    }
                }

            }
        })
    }
    function getUserInfo() {
        const data = {
            Command: configData.GET_USER_DETAILS,
            SecurityId: "",
            SecurityToken: localStorage.getItem("SecurityToken"),
            EventContextId: "",
            CallerSourceId: "",
            CallerSourceName: "",
        };
        const params = {
            FunctionName: configData.LAMBDA_FUNCTION_NAME1,
            Payload: JSON.stringify(data),
        };
        lambda.invoke(params, (err, data) => {
            if (err) {
                console.log(err, err.stack);
            } else {
                let response = JSON.parse(JSON.parse(JSON.parse(JSON.parse(JSON.stringify(data.Payload))).body).Output);
                // admindetails = response;
                setAdmindetails(response)




                let defaultmapping = JSON.parse(localStorage.getItem("CurrentMapping"));
                console.log("userMappingData", userMappingData)
                localStorage.setItem("DefaultUseCase", defaultmapping.UseCaseId);
                localStorage.setItem("UseCaseShortName", defaultmapping.UCSN);
                localStorage.setItem("ClientShortName", defaultmapping.CSN);
                //newly added
                console.log("defaultmapping", defaultmapping)
                mappingIDForUser = defaultmapping.UserMapId;
                setUsecaseForMapping(defaultmapping.UseCaseId);
                setClientForMapping(defaultmapping.ClientId);
                setUserRoleForMapping(defaultmapping.RoleMasterId);
                setMainClientValue(defaultmapping.ClientId)
                setMainUsecaseValue(defaultmapping.UseCaseId)
                // getRolesAndRights(mappingIDForUser);

                usecaseList = [];
                userRoleList = [];
                clientList = [];
                let mappingDetails = userMappingData.filter(el => el.UseCaseId == defaultmapping.UseCaseId && el.ClientId == defaultmapping.ClientId);
                console.log("getUserInfo() - mappingDetails", mappingDetails);
                // if (mappingDetails.length > 1) {
                for (let i = 0; i < userMappingData.length; i++) {
                    if ((usecaseList.length == 0) || (usecaseList.length > 0 && !usecaseList.some(el => el.UseCaseId == userMappingData[i].UseCaseId))) {
                        usecaseList.push({ "UseCaseId": userMappingData[i].UseCaseId, "UseCaseName": userMappingData[i].UseCaseName })
                    }
                }
                setDisableClientMapping(false);
                setDisableRoleMapping(false);
                for (let i = 0; i < mappingDetails.length; i++) {
                    if ((userRoleList.length == 0) || (userRoleList.length > 0 && !userRoleList.some(el => el.RoleMasterId == mappingDetails[i].RoleMasterId))) {
                        userRoleList.push({ "RoleMasterId": mappingDetails[i].RoleMasterId, "RoleName": mappingDetails[i].RoleName })
                    }
                    if ((clientList.length == 0) || (clientList.length > 0 && !clientList.some(el => el.ClientId == mappingDetails[i].ClientId))) {
                        clientList.push({ "ClientId": mappingDetails[i].ClientId, "ClientName": mappingDetails[i].ClientName })
                    }
                }
                setUsecaseForMapping(defaultmapping.UseCaseId);
                setClientForMapping(defaultmapping.ClientId);
                setUserRoleForMapping(defaultmapping.RoleMasterId);
                // } else {
                //   // setDisableClientMapping(true);
                //   // setDisableRoleMapping(true);
                //   for (let i = 0; i < userMappingData.length; i++) {
                //     if ((usecaseList.length == 0) || (usecaseList.length > 0 && !usecaseList.some(el => el.UseCaseId == userMappingData[i].UseCaseId))) {
                //       usecaseList.push({ "UseCaseId": userMappingData[i].UseCaseId, "UseCaseName": userMappingData[i].UseCaseName })
                //     }
                //   }
                //   setUsecaseForMapping(defaultmapping.UseCaseId);
                //   setClientForMapping(defaultmapping.ClientId);
                //   setUserRoleForMapping(defaultmapping.RoleMasterId);
                // }

                // userMappingDataForSupervisor = userMappingData.filter(el => el.RoleName == "IDX Supervisor");
                userMappingDataForSupervisor = userMappingData.filter(el => el.RoleName == "DG-SuperAdmin");

                console.log("userMappingDataForSupervisor", userMappingDataForSupervisor)
                let userUsecases = [], userClients = [];
                for (let z = 0; z < userMappingDataForSupervisor.length; z++) {
                    if ((userUsecases.length == 0) || (userUsecases.length > 0 && !(userUsecases.some(el => el.UseCaseId == userMappingDataForSupervisor[z].UseCaseId)))) {
                        userUsecases.push({ "UseCaseId": userMappingDataForSupervisor[z].UseCaseId, "UseCaseName": userMappingDataForSupervisor[z].UseCaseName });
                    }
                }
                let supervisorMapping = userMappingDataForSupervisor.filter(el => el.UseCaseId == defaultmapping.UseCaseId);
                console.log("supervisorMapping", supervisorMapping)
                for (let z = 0; z < supervisorMapping.length; z++) {
                    if ((userClients.length == 0) || (userClients.length > 0 && !(userClients.some(el => el.ClientId == supervisorMapping[z].ClientId)))) {
                        userClients.push({ "ClientId": supervisorMapping[z].ClientId, "ClientName": supervisorMapping[z].ClientName });
                    }
                }
                console.log("getUserInfo() - userUsecases, userClients", userUsecases, userClients);
                setUsecasesForSupervisorDrpDwn(userUsecases);
                setClientsForSupervisorDrpDwn(userClients);
                // usecaseListForLoanCreation = [{ "UseCaseID": defaultmapping.UseCaseId, "UseCaseName": defaultmapping.UseCaseName }];
                setUsecaseListForLoanCreation([{ "UseCaseID": defaultmapping.UseCaseId, "UseCaseName": defaultmapping.UseCaseName }])
                console.log(usecaseListForLoanCreation, 'usecaseListForLoanCreation')
                setCreateLoanUsecase(defaultmapping.UseCaseId);
                // clientListForLoanCreation = [{ "ClientID": defaultmapping.ClientId, "ClientName": defaultmapping.ClientName }];
                setClientListForLoanCreation([{ "ClientID": defaultmapping.ClientId, "ClientName": defaultmapping.ClientName }])
                setCreateLoanClient(defaultmapping.ClientId);
            }
        });
    }

    function getUsersList() {
        setDotLoader(false);
        const inputJson = {
            Command: configData.GET_USERS_LIST,
            SecurityId: "",
            SecurityToken: localStorage.getItem("SecurityToken"),
            EventContextId: "",
            CallerSourceId: "",
            CallerSourceName: "",
        };
        const parameters = {
            FunctionName: configData.LAMBDA_FUNCTION_NAME1,
            Payload: JSON.stringify(inputJson),
        };
        lambda.invoke(parameters, (err, data) => {
            if (err) {
                console.log(err, err.stack);
            } else {
                if (JSON.parse(JSON.parse(JSON.parse(JSON.stringify(data.Payload))).statusCode) == 200) {
                    if (JSON.parse(JSON.parse(JSON.parse(JSON.parse(JSON.stringify(data.Payload))).body).Status) == true) {
                        let response = JSON.parse(
                            JSON.parse(JSON.parse(JSON.parse(JSON.stringify(data.Payload))).body)
                                .Output
                        );
                        console.log("GET_USERS_LIST - response", response.UsersList);
                        usersList = response.UsersList;
                        userSecurityId = usersList.find(el => el.UserName == localStorage.getItem("UserName")).SecurityId;
                        getDetailsForSelectedUser();
                        setDotLoader(true);
                    } else {
                        toast.error("Failed to fetch the list of users. Please refresh and try again.", {
                            position: "bottom-center",
                            autoClose: 2000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                        });
                    }
                } else {
                    console.log("admin.js - getUsersList()");
                    alert("Internal server error. Please try again");
                }
            }
        });
    }

    const getRolesAndRights = (mappingID) => {
        let getupdatemappingdata = userMappingData.filter(x => x.UserMapId === Number(localStorage.getItem('mappingIDForUser')))
        setMainUsecaseValue(getupdatemappingdata[0].UseCaseId);
        setMainClientValue(getupdatemappingdata[0].ClientId);
        console.log(getupdatemappingdata, "getupdatemappingdata")
        let inputJson = {
            Command: configData.GET_USER_ROLE_RIGHTS_BY_USER_MAPID,
            SecurityId: "",
            SecurityToken: localStorage.getItem("SecurityToken"),
            EventContextId: "",
            CallerSourceId: "",
            CallerSourceName: "",
            UserMapId: Number(localStorage.getItem('mappingIDForUser'))
        }
        const params = {
            FunctionName: configData.LAMBDA_FUNCTION_NAME1,
            Payload: JSON.stringify(inputJson),
        };
        lambda.invoke(params, (err, data) => {
            if (err) {
                console.log(err, err.stack);
            } else {
                if (JSON.parse(JSON.parse(JSON.parse(JSON.stringify(data.Payload))).statusCode) == 200) {
                    if (JSON.parse(JSON.parse(JSON.parse(JSON.parse(JSON.stringify(data.Payload))).body).Status) == true) {
                        let response = JSON.parse(JSON.parse(JSON.parse(JSON.parse(JSON.stringify(data.Payload))).body).Output);
                        console.log("response", response.RoleRights);
                        localStorage.setItem("Rights", JSON.stringify(response.RoleRights));
                        mappingIDForUser = Number(localStorage.getItem('mappingIDForUser'));
                        userSecurityId = usersList.find(el => el.UserName == localStorage.getItem("UserName")).SecurityId;
                        // getDetailsForSelectedUser();
                        // getDashboardData();
                    }
                }
            }
        });
        getDashboardDataForGrid();
        getClientMetaKey();
    }
    const [usermappingDetails, setUsermappingDetails] = useState();
    function getDetailsForSelectedUser() {
        const inputJson = {
            Command: configData.GET_USER_MAPPING_DETAILS,
            SecurityId: "",
            SecurityToken: localStorage.getItem("SecurityToken"),
            EventContextId: "",
            CallerSourceId: "",
            CallerSourceName: "",
            UserSecurityId: userSecurityId,
        };
        const parameters = {
            FunctionName: configData.LAMBDA_FUNCTION_NAME1,
            Payload: JSON.stringify(inputJson),
        };
        lambda.invoke(parameters, (err, data) => {
            if (err) {
                console.log(err, err.stack);
            } else {
                let response = JSON.parse(
                    JSON.parse(JSON.parse(JSON.parse(JSON.stringify(data.Payload))).body)
                        .Output
                );
                console.log(
                    "GET_USER_MAPPING_DETAILS - response",
                    response.UserMappingInfo
                );
                userMappingData = response.UserMappingInfo;
                localStorage.setItem("UserMappingData", JSON.stringify(response.UserMappingInfo))
                setUsermappingDetails(response.UserMappingInfo)
                setShowHeader(true);
                let defaultmapping = JSON.parse(localStorage.getItem("CurrentMapping"));
                console.log("userMappingData", userMappingData)
                localStorage.setItem("DefaultUseCase", defaultmapping.UseCaseId);
                localStorage.setItem("UseCaseShortName", defaultmapping.UCSN);
                localStorage.setItem("ClientShortName", defaultmapping.CSN);
                //newly added
                console.log("defaultmapping", defaultmapping)
                mappingIDForUser = localStorage.getItem("mappingIDForUser");
                setUsecaseForMapping(defaultmapping.UseCaseId);
                usecaseForSwitchAcc = defaultmapping.UseCaseId;
                setClientForMapping(defaultmapping.ClientId);
                clientForSwitchAcc = defaultmapping.ClientId;
                setUserRoleForMapping(defaultmapping.RoleMasterId);
                userRoleForSwitchAcc = defaultmapping.RoleMasterId;
                // getRolesAndRights(mappingIDForUser);

                usecaseList = [];
                userRoleList = [];
                clientList = [];
                let mappingDetails = userMappingData.filter(el => el.UseCaseId == defaultmapping.UseCaseId && el.ClientId == defaultmapping.ClientId);
                console.log("getUserInfo() - mappingDetails", mappingDetails);
                // if (mappingDetails.length > 1) {
                for (let i = 0; i < userMappingData.length; i++) {
                    if ((usecaseList.length == 0) || (usecaseList.length > 0 && !usecaseList.some(el => el.UseCaseId == userMappingData[i].UseCaseId))) {
                        usecaseList.push({ "UseCaseId": userMappingData[i].UseCaseId, "UseCaseName": userMappingData[i].UseCaseName })
                    }
                }
                setDisableClientMapping(false);
                setDisableRoleMapping(false);
                for (let i = 0; i < mappingDetails.length; i++) {
                    if ((userRoleList.length == 0) || (userRoleList.length > 0 && !userRoleList.some(el => el.RoleMasterId == mappingDetails[i].RoleMasterId))) {
                        userRoleList.push({ "RoleMasterId": mappingDetails[i].RoleMasterId, "RoleName": mappingDetails[i].RoleName })
                    }
                    if ((clientList.length == 0) || (clientList.length > 0 && !clientList.some(el => el.ClientId == mappingDetails[i].ClientId))) {
                        clientList.push({ "ClientId": mappingDetails[i].ClientId, "ClientName": mappingDetails[i].ClientName })
                    }
                }
                setUsecaseForMapping(defaultmapping.UseCaseId);
                usecaseForSwitchAcc = defaultmapping.UseCaseId;
                setClientForMapping(defaultmapping.ClientId);
                clientForSwitchAcc = defaultmapping.ClientId;
                setUserRoleForMapping(defaultmapping.RoleMasterId);
                userRoleForSwitchAcc = defaultmapping.RoleMasterId;
                // } else {
                //   // setDisableClientMapping(true);
                //   // setDisableRoleMapping(true);
                //   for (let i = 0; i < userMappingData.length; i++) {
                //     if ((usecaseList.length == 0) || (usecaseList.length > 0 && !usecaseList.some(el => el.UseCaseId == userMappingData[i].UseCaseId))) {
                //       usecaseList.push({ "UseCaseId": userMappingData[i].UseCaseId, "UseCaseName": userMappingData[i].UseCaseName })
                //     }
                //   }
                //   setUsecaseForMapping(defaultmapping.UseCaseId);
                //   setClientForMapping(defaultmapping.ClientId);
                //   setUserRoleForMapping(defaultmapping.RoleMasterId);
                // }

                // userMappingDataForSupervisor = userMappingData.filter(el => el.RoleName == "IDX Supervisor");
                userMappingDataForSupervisor = userMappingData.filter(el => el.RoleName == "DG-SuperAdmin");

                console.log("userMappingDataForSupervisor", userMappingDataForSupervisor)
                let userUsecases = [], userClients = [];
                for (let z = 0; z < userMappingDataForSupervisor.length; z++) {
                    if ((userUsecases.length == 0) || (userUsecases.length > 0 && !(userUsecases.some(el => el.UseCaseId == userMappingDataForSupervisor[z].UseCaseId)))) {
                        userUsecases.push({ "UseCaseId": userMappingDataForSupervisor[z].UseCaseId, "UseCaseName": userMappingDataForSupervisor[z].UseCaseName });
                    }
                }
                let supervisorMapping = userMappingDataForSupervisor.filter(el => el.UseCaseId == localStorage.getItem("AdvancedFilterUseCase"));
                console.log("supervisorMapping", supervisorMapping)
                for (let z = 0; z < supervisorMapping.length; z++) {
                    if ((userClients.length == 0) || (userClients.length > 0 && !(userClients.some(el => el.ClientId == supervisorMapping[z].ClientId)))) {
                        userClients.push({ "ClientId": supervisorMapping[z].ClientId, "ClientName": supervisorMapping[z].ClientName });
                    }
                }
                console.log("getUserInfo() - userUsecases, userClients", userUsecases, userClients);
                setUsecasesForSupervisorDrpDwn(userUsecases);
                setClientsForSupervisorDrpDwn(userClients);
                // usecaseListForLoanCreation = [{ "UseCaseID": defaultmapping.UseCaseId, "UseCaseName": defaultmapping.UseCaseName }];
                setUsecaseListForLoanCreation([{ "UseCaseID": defaultmapping.UseCaseId, "UseCaseName": defaultmapping.UseCaseName }])
                setCreateLoanUsecase(defaultmapping.UseCaseId);
                // clientListForLoanCreation = [{ "ClientID": defaultmapping.ClientId, "ClientName": defaultmapping.ClientName }];
                setClientListForLoanCreation([{ "ClientID": defaultmapping.ClientId, "ClientName": defaultmapping.ClientName }])
                setCreateLoanClient(defaultmapping.ClientId);
            }
        });
    }
    const formatCurrency = (value) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value);
    };
    const handleFilterChange = (filterType) => {
        if (filterType === 'TOTAL_LOANS') {
            setActiveFilter('');
        } else {
            setActiveFilter(filterType);
        }
    };

    const handleSearchChange = (event) => {
        setSearchText(event.target.value);
    };




    const handleSearchButtonClick = () => {
        getDashboardDataForGrid();
    };
    const onDashboardGridRefresh = () => {
        setLoannoSearchErrorValue('')
        getDashboardDataForGrid();
    }
    // const handleFromDateChange = (event) => {
    //     setFromDate(event.target.value);
    // };

    // const handleToDateChange = (event) => {
    //     setToDate(event.target.value);
    // };

    // Filter loan details based on search text and date range
    // const filteredLoanDetails = useMemo(() => {
    //     if (!searchText) return data.LnDtls || [];
    //     const lowerCaseSearchText = searchText.toLowerCase();
    //     return (data.LnDtls || []).filter(loan =>
    //         Object.values(loan).some(value =>
    //             value && value.toString().toLowerCase().includes(lowerCaseSearchText)
    //         )
    //     );
    // }, [data.LnDtls, searchText]);
    const customTooltip = (text) => (
        <Tooltip id="tooltip">{text}</Tooltip>
    );


    const getStatusClass = (status) => {
        // console.log(status[0])
        if (status[0] === "Published") {
            return "text-primary";
        } else if (status[0] === "Pending IG Results") {
            return "text-secondary";
        } else if (status[0] === "Ready For Review") {
            return "text-success";
        } else if (status[0] === "Review for Approval") {
            return "text-danger";
        } else if (status[0] === "In Progress") {
            return "text-warning";
        } else if (status[0] === "Loan Created") {
            return "text-info";
        } else if (status[0] === "Review for Approval") {
            return "text-dark";

        } else {
            return "text-dark";
        }
    };
    const dashboardJsonData = dashboardJson.LnDtls;


    //console.log(dashboardJsonData);
    // const dashboardgriddata = dashboardJsonData.map(item => ({
    //     LoanNo: item.LnNo,
    //     blastname: item.BLName,
    //     product: item.LnPrgm,
    //     loanamount: item.LnAmt,
    //     loanpurpose: item.LnPurpose,
    //     propertyaddress: item.ProptyAdd,
    //     lockexpiration: item.LockExp,
    //     status: item.LnSts.map(statusvalue => statusvalue.Sts),
    //     statuscss: getStatusClass(item.LnSts.map(statusvalue => statusvalue.Sts)),
    //     approvalstatus: item.AprSts,
    //     OrdDtls: item.OrdDtls || []


    // }))
    const navigate = useNavigate();
    const goToGeneralInformationPage = () => {
        navigate('/general-information');
    };
    // Loan search fix and enter key function
    // function loanSearchInput(event) {
    const [loannoSearchValue, setLoannoSearchValue] = useState('');
    const [loannoSearchErrorValue, setLoannoSearchErrorValue] = useState('');
    const loanSearchInput = (event) => {
        console.log("loanSearchInput() - event", event);
        const excludedColumns = ['LK', 'LEC', 'LG', 'CLN', 'Lckby'];
        const searchValue = event.target.value.toLowerCase();
        setLoannoSearchValue(searchValue)
        // If the search value is empty, return the original data
        if (searchValue === '') {
            setLoannoSearchErrorValue('Please enter at least one valid search criteria')
            setDashboardGridLoanDeatails(originalDashboardData);
            return;
        }
        else {
            setLoannoSearchErrorValue('')

        }

        const filteredData = originalDashboardData.filter((item) => {
            return Object.keys(item).some((key) => {
                if (!excludedColumns.includes(key)) {
                    const value = item[key];
                    return value != null && value.toString().toLowerCase().includes(searchValue);
                }
                return false;
            });
        });

        console.log(filteredData);
        setDashboardGridLoanDeatails(filteredData);
        let searchInput = document.getElementById('loanNumberSearchInput');
        searchInput.addEventListener('keypress', function (e) {
            if (e.key == "Enter") {
                console.log(e);
                loanNumberSearch = e.target.value
                // loanNumberSearch = e.target.value.trim();
                onDashboardGridRefresh();
            }
        });

    }
    const loannoSearchOnBtnClick = () => {
        if (loannoSearchValue === '') {
            setLoannoSearchErrorValue('Please enter at least one valid search criteria')
        }
        else {
            loanNumberSearch = loannoSearchValue;
            onDashboardGridRefresh();
            setLoannoSearchErrorValue("")
        }
    }
    // Loan Import Data New Window Open

    // create Loan UseState and Variable Declarion 
    // selectedfiles = []
    // const [listOfSelectedfiles, setListOfSelectedfiles] = useState([]);
    // const [existLoanGuid, setExistLoanGuid] = useState(null);
    // createLoanFlag = true,

    //     //Create Loan
    //     function getCreateLoanFlag() {
    //         selectedfiles = [];
    //         setListOfSelectedfiles([]);
    //         setExistLoanGuid(null);
    //         console.log("setListOfSelectedfiles(), setExistLoanGuid()", listOfSelectedfiles, existLoanGuid);
    //         createLoanFlag = true;
    //         handleShow();
    //     }
    // Transform the loan data to match the headers
    const data1 = dashboardGridLoanDeatails.map(loan => ({
        // LG: loan.LG,
        // CLN: loan.CLN,
        LoanNo: loan.LN, // Change the key to "LoanNo": loan.LN,
        BLN: loan.BLN,
        PRO: loan.PRO,
        LP: loan.LP,
        LA: loan.LA,
        PA: loan.PA,
        LE: loan.LE,
        LSts: loan.LSts,
        InLSts: loan.InLSts,
        AprSts: loan.AprSts,
    }));
    const today = new Date();
    const fiveDaysAgo = new Date();
    fiveDaysAgo.setDate(today.getDate() - 29);

    const [dateRange, setDateRange] = useState({
        fromDate: fiveDaysAgo,
        toDate: today,
    });
    const [error, setError] = useState('');

    const handleDateChange = (fromDate, toDate) => {
        setDateRange({ fromDate, toDate });
    };
    const formatDate = (date) => {
        if (!date) return '';
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}/${month}/${day}`;
    };
    const isButtonDisabled = !dateRange.fromDate || !dateRange.toDate;
    const handleTilesFilterChange = (tilesFilter) => {
        console.log(originalDashboardData)
        const filteredLoanDetails = originalDashboardData.filter(loan =>
            loan.LF.some(item => item.TSN === tilesFilter)
        );
        setDashboardGridLoanDeatails(filteredLoanDetails);
        console.log(dashboardGridLoanDeatails)
    }
    const handleShowLoan = () => {
        localStorage.setItem('showaddfilesloanpopup', false);
        localStorage.setItem('showloancreatepopup', true);
        setShowhideLoan(Boolean(localStorage.getItem('showloancreatepopup')));
    }
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const handleResetPagination = () => {
        setResetPaginationToggle(prev => !prev);
    };
    const [tosterDatausecase, setTosterDatausecase] = useState([]);
    const [tosterDataclient, setTosterDataclient] = useState([]);
    const MainUseCaseChange = (usecasevalue) => {
        let getselectedUseCaseValue = usecasevalue;
        setMainUsecaseValue(usecasevalue)
        defaultUseCase = usecasevalue;
        let getFilteredClientName = userMappingData.filter(x => Number(x.UseCaseId) === Number(getselectedUseCaseValue));
        console.log(getFilteredClientName)
        let FilterUniqueclientList = Array.from(
            getFilteredClientName?.reduce((map, obj) => map.set(obj.ClientId, obj), new Map()).values()
        );
        setClientsForSupervisorDrpDwn(FilterUniqueclientList)
        setTosterDatausecase(userMappingData.filter(x => Number(x.UseCaseId) === Number(getselectedUseCaseValue))[0].UseCaseName)
    }
    const MainClientChange = (clientvalue) => {
        const getselectedClientList = clientvalue;
        setMainClientValue(clientvalue)
        defaultCient = clientvalue;
        let getFilteredClientName = usermappingDetails.filter(x => Number(x.ClientId) === Number(getselectedClientList));
        let FilterUniqueRoleList = Array.from(
            getFilteredClientName?.reduce((map, obj) => map.set(obj.RoleMasterId, obj), new Map()).values()
        );
        console.log(FilterUniqueRoleList, 'getFilteredClientName');
        let getDGSuperadminRole = FilterUniqueRoleList.filter(x => x.RoleName === "DG-SuperAdmin")
        localStorage.setItem("mappingIDForUser", getDGSuperadminRole[0].UserMapId);
        setTosterDataclient(userMappingData.filter(x => Number(x.ClientId) === Number(getselectedClientList))[0].ClientName)
    }
    const mainswitchaccount = () => {
        getDashboardDataForGrid();
        getClientMetaKey();
        toast.success("Data is configured to " + tosterDatausecase + " and " + tosterDataclient, {
            position: "bottom-center",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }
    const handleInputChange = (event) => {
        setSearchValue(event.target.value); // Update local state
        loanSearchInput(event);            // Keep your original function working
    };

    const clearInput = () => {
        setSearchValue(''); // Resets the textbox
        // Optional: if your original function needs to know it's cleared:
        loanSearchInput({ target: { value: '' } });
    };
    useEffect(() => {
        document.body.classList.add('no-scroll');
        return () => document.body.classList.remove('no-scroll');
    }, []);
    return (
        <>
            {showHeader && <Header usermappingDetails={usermappingDetails} getRolesAndRights={getRolesAndRights} />}
            {dotloader ? (
                <main className="main-content">
                    {dashboardTilesData.length > 0 && <DashboardTiles tilesData={dashboardTilesData} onfilterChange={handleTilesFilterChange} onResetPagination={handleResetPagination} />}
                    <div className="card mb-1">
                        <div className="card-header p-0 p-2">
                            <div className="d-flex flex-nowrap">

                                <div className="flex-fill">
                                    <div className="d-flex">
                                        <DashboardDatepicker onDateChange={handleDateChange} setError={setError}
                                            initialFromDate={dateRange.fromDate ? new Date(dateRange.fromDate) : defaultfromDate}
                                            initialToDate={dateRange.toDate ? new Date(dateRange.toDate) : defaulttoDate}
                                        />
                                        <div className="ms-2">
                                            <TooltipTop title="Search Loan">
                                                <button
                                                    onClick={handleSearchButtonClick}
                                                    disabled={isButtonDisabled}
                                                    className="btn btn-sm btn-primary"
                                                >
                                                    <i className="ri-search-line"></i> Search
                                                </button>
                                            </TooltipTop>
                                        </div>
                                        <div className="ms-2">
                                            <button onClick={() => { handleCreateLoan(); handleShowLoan(); }} className="btn btn-sm btn-primary text-nowrap">
                                                <i className="ri-function-add-line"></i> Create Loan
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {localStorage.getItem("Role") === "DG-SuperAdmin" && <div className="flex-fill">
                                    <Row>
                                        <Col sm={5} className='pe-0'>
                                            <Form.Select size="sm" value={mainUsecaseValue} onChange={(e) => MainUseCaseChange(e.target.value)}>
                                                <option disabled>--Select Usecase--</option>
                                                {usecasesForSupervisorDrpDwn.length !== 0 && usecasesForSupervisorDrpDwn?.map((el) => (
                                                    <option value={el.UseCaseId}>{el.UseCaseName}</option>
                                                ))}
                                            </Form.Select>
                                        </Col>
                                        <Col sm={5} className='pe-0'>
                                            <Form.Select size="sm" value={mainClientValue} onChange={(e) => MainClientChange(e.target.value)}>
                                                <option disabled>--Select Client--</option>
                                                {clientsForSupervisorDrpDwn.length !== 0 && clientsForSupervisorDrpDwn?.map((el) => (
                                                    <option value={el.ClientId}>{el.ClientName}</option>
                                                ))}
                                            </Form.Select>
                                        </Col>
                                        <Col sm={2} className='d-flex align-items-center'><RiArrowRightCircleFill onClick={mainswitchaccount} style={{ fontSize: '18px', color: '#000000' }} /></Col>
                                    </Row>

                                </div>}
                                <div className="flex-fill">
                                    <div className='d-flex justify-content-end'>


                                    </div>
                                </div>
                                {/*    <div className="flex-grow-1">
                                    <div className="input-group" id="positionFilter">
                                        <input
                                            id="loanNumberSearchInput"
                                            type="text"
                                            placeholder="Please enter at least one valid search criteria"
                                            onChange={(event) => loanSearchInput(event)}
                                            className="form-control form-control-sm"
                                        />
                                        <button
                                            className="btn btn-sm btn-primary-light"
                                            type="button"
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            title="Search Loan"
                                            onClick={loannoSearchOnBtnClick}
                                        >
                                            <i className="ri-search-line"></i>
                                        </button>
                                        {loannoSearchErrorValue !== '' && <p className="loansearcherrormsg">{loannoSearchErrorValue}</p>}
                                    </div>
                                </div>*/}
                                <div className="flex-grow-1">
                                    <div className="input-group" id="positionFilter" style={{ width: 'fit-content' }}>
                                        <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                            <input
                                                id="loanNumberSearchInput"
                                                type="text"
                                                className="form-control form-control-sm"
                                                style={{ minWidth: '270px', paddingRight: '10px' }} // Space for the 'X'
                                                placeholder="Please enter at least one valid search criteria"
                                                value={searchValue} // Linked to state
                                                onChange={handleInputChange}
                                            />
                                            {searchValue && (
                                                <i
                                                    className="ri-close-circle-fill"
                                                    onClick={clearInput}
                                                    style={{
                                                        position: 'absolute',
                                                        right: '10px',
                                                        cursor: 'pointer',
                                                        zIndex: 10,
                                                        color: '#216ba5' // Subtle grey
                                                    }}
                                                ></i>
                                            )}
                                        </div>

                                        <button
                                            className="btn btn-sm btn-primary-light"
                                            type="button"
                                            onClick={loannoSearchOnBtnClick}
                                        >
                                            <i className="ri-search-line"></i>
                                        </button>
                                    </div>
                                    {loannoSearchErrorValue !== '' && <p className="loansearcherrormsg">{loannoSearchErrorValue}</p>}
                                </div>
                                <div className="ms-2">
                                    <TooltipTop title="Refresh Loans">
                                        <button
                                            onClick={onDashboardGridRefresh}
                                            className="btn btn-sm btn-secondary">
                                            <i className="ri-refresh-line"></i>
                                        </button>
                                    </TooltipTop>
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-sm-6">
                                    {error && <p className='mt-1 mb-0' style={{ color: 'red' }}>{error}</p>} {/* Display error message */}
                                </div>
                            </div>
                        </div>
                        <div className="card-body p-0 dashboard-grid">
                            {dashboardGridLoanDeatails.length > 0 ? <DashboardGridData
                                headers={dashboardGridHeader}
                                data={dashboardGridLoanDeatails}
                                usecaseListForFileCreations={usecaseListForLoanCreation}
                                clientListForFileCreations={clientListForLoanCreation}
                                admindetailsFromMainForFileCreation={admindetails} resetPaginationToggle={resetPaginationToggle} createLoanUsecaseid={createLoanUsecase}
                                createLoanClientid={createLoanClient} /> : <div className='d-flex align-items-center justify-content-center' style={{ height: 'calc(100vh - 240px)' }}><p>No Data available</p></div>}
                        </div>
                    </div>
                    {showhideLoan && <CreateLoan
                        show={showCreateLoan}
                        handleClose={closeCreateLoan}
                        usecaseListForLoanCreations={usecaseListForLoanCreation}
                        clientListForLoanCreations={clientListForLoanCreation}
                        admindetailsFromMain={admindetails}
                        createLoanUsecaseid={createLoanUsecase}
                        createLoanClientid={createLoanClient}
                        loanDetatils={null}
                        isNewLoan={true}
                    />}
                </main>
            ) : (
                <div style={{ marginTop: "20%", marginBottom: "20%" }} className="d-flex justify-content-center">
                    <div className="loader"></div>
                </div>
            )}
        </>
    );
};

export default MainContent;
